// Zero-specific per-tab UI preferences that may hold demo ids. Cleared when a demo
// session starts and when it ends (the core clears tokens, org and help-guide keys).

const ZERO_DEMO_PREFERENCE_KEYS = [
  'reportPreferences',
  'zeroOverviewSelectedStats',
  'zeroMonthlySelectedExtras',
  'zeroOverviewSelectedExtras',
  'zero.onboarding.liveSession',
] as const;

export function clearZeroDemoPreferences(): void {
  for (const key of ZERO_DEMO_PREFERENCE_KEYS) {
    try {
      globalThis.sessionStorage?.removeItem(key);
    } catch {
      /* storage unavailable */
    }
  }
}
